import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

function ContenedoresActivos({
  onClose,
  valorActual,
  actualizarTarifa,
  concepto,
}) {
  const [rkn, setRkn] = useState("");
  const [rap, setRap] = useState("");
  const [reporteTemperatura, setReporteTemperatura] = useState("");

  // 🔹 Cargar datos simulados del back
  useEffect(() => {
    if (valorActual) {
      setRkn(valorActual.rkn || "");
      setRap(valorActual.rap || "");
      setReporteTemperatura(valorActual.reporte_temperatura || "");
    }
  }, [valorActual]);

  const handleActualizar = () => {
    actualizarTarifa(concepto, {
      rkn,
      rap,
      reporte_temperatura: reporteTemperatura,
    });

    Swal.fire({
      title: "Éxito",
      text: "Contenedores activos actualizados correctamente",
      icon: "success",
    }).then(() => {
      onClose();
    });
  };

  return (
    <>
      {/* Aquí va la estructura específica */}
      <div className="container-fluid d-flex justify-content-center align-items-center">
        <div className="text-left" style={{ width: "450px" }}>
          <div className="row mb-4">
            <label className="fw-bold d-block mb-2">
              MANEJO DE CONTENEDORES ACTIVOS (RKN)
            </label>
            <input
              type="number"
              className="form-control"
              value={rkn}
              onChange={(e) => setRkn(e.target.value)}
            />
          </div>

          <div className="row mb-4">
            <label className="fw-bold d-block mb-2">
              MANEJO DE CONTENEDORES ACTIVOS (RAP)
            </label>
            <input
              type="number"
              className="form-control"
              value={rap}
              onChange={(e) => setRap(e.target.value)}
            />
          </div>

          <div className="row mb-4">
            <label className="fw-bold d-block mb-2">
              REPORTE DE TEMPERATURA (USD)
            </label>
            <input
              type="number"
              className="form-control"
              value={reporteTemperatura}
              onChange={(e) => setReporteTemperatura(e.target.value)}
            />
          </div>

          <div className="d-flex justify-content-end">
            <button className="btnn" onClick={handleActualizar}>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContenedoresActivos;
